'use client';

import { useTheme } from 'next-themes';

export type ColorMode = 'light' | 'dark';

export interface UseColorModeReturn {
	colorMode: ColorMode;
	setColorMode: (colorMode: ColorMode) => void;
	toggleColorMode: () => void;
}

export function useColorMode(): UseColorModeReturn {
	const { resolvedTheme, setTheme, forcedTheme } = useTheme();
	const colorMode = (forcedTheme || resolvedTheme) as ColorMode;
	const toggleColorMode = () => {
		setTheme(colorMode === 'dark' ? 'light' : 'dark');
	};
	return {
		colorMode,
		setColorMode: setTheme,
		toggleColorMode,
	};
}

export function useColorModeValue<T>(light: T, dark: T) {
	const { colorMode } = useColorMode();
	return colorMode === 'dark' ? dark : light;
}
